import { HttpService } from '@/core'
import {whiteList} from "@/core/setup/setupRouterGuards"
import {useRoute} from "vue-router"
import {ref,reactive} from "vue"
export interface WarnMessage {
  content: string;
  id: string;
  title: string;
}

export class GlobalMsgResp {
  num: number = 0
  userId: string = ''
  wornMessages: WarnMessage[] = []
}


export default class GlobalMsgService {
  static queryGlobalMsgInfo () {
    const route = useRoute();
    if(!whiteList.includes(route.path)){
      const api = () =>
        HttpService.axios({
          url: '/message_center/polling',
          method: 'POST',
        })
      return HttpService.useRequest<GlobalMsgResp>(api)
    }else{
      return  { data:ref({num:0,wornMessages:[]as WarnMessage[]}), loading:ref(false), run:()=>{}, refresh:()=>{} };
    }
  }
}
